// Exported constants for the types of resources that are built
export const resourceTypeArchive = "archive";
export const resourceTypeGroup = "group";
export const resourceTypePublicFolder = "public";
export const resourceTypeShared = "shared";
export const resourceTypeAutomappedShared = "shareda";
export const resourceTypeTeams = "teams";
export const resourceTypeTeamRhythm = "teamrhythm";
export const resourceTypeLicense = "license";
